import { call, put, takeLatest } from "redux-saga/effects";
import {
  TOGGLE_COMPETITOR_STATUS_REQUEST,
  toggleCompetitorStatusSuccess,
  toggleCompetitorStatusFailure,
} from "../actions/competitorStatusActions";
import { toggleCompetitorStatus } from "../../../services/accIqService";
import { submitCompetitorListRequest } from "../actions/competitorListActions";

function* toggleCompetitorStatusWorker(action) {
  try {
    const { client, company, flag } = action.payload;

    yield call(toggleCompetitorStatus, {
      client,
      company,
      flag,
    });

    yield put(toggleCompetitorStatusSuccess());

    // refresh competitor list after toggle
    yield put(submitCompetitorListRequest(client));
  } catch (error) {
    yield put(
      toggleCompetitorStatusFailure(
        error?.message || "Failed to update competitor status"
      )
    );
  }
}

export function* watchToggleCompetitorStatus() {
  yield takeLatest(
    TOGGLE_COMPETITOR_STATUS_REQUEST,
    toggleCompetitorStatusWorker
  );
}
